export interface UiGuideViewStatus {
    guide: UiGuide;
    viewed: boolean;
    dateViewed: string;
}

export enum UiGuide {
    CORE_GUIDE = 'CORE_GUIDE',
    PRO_GUIDE = 'PRO_GUIDE',
    VIP_GUIDE = 'VIP_GUIDE'
}
